{
  "optimizationInputsForm": {
    "sections": {
      "initialDimensions": "Initial Dimensions",
      "variations": "Variations",
      "sizesToTest": "Sizes to Test",
      "aircraftMix": "Aircraft Mix"
    },
    "labels": {
      "width": "Width ({{unit}})",
      "depth": "Depth ({{unit}})",
      "widthVariation": "+/- width ({{unit}})",
      "depthVariation": "+/- depth ({{unit}})",
      "searchAircraft": "Search by make and model",
      "numberAircraft": "# Aircraft",
      "configurations": "configurations"
    },
    "tableHeaders": {
      "make": "Make",
      "model": "Model",
      "wingspan": "Wingspan ({{unit}})",
      "length": "Length ({{unit}})",
      "tailHeight": "Tail Height ({{unit}})"
    }
  },
  "optimizationHangarResults": {
    "buttons": {
      "stop": "Stop",
      "run": "Run"
    },
    "tableHeaders": {
      "hangar": "Hangar",
      "doors": "Doors",
      "progress": "Progress",
      "numberInHangar": "# in Hangar",
      "utilization": "Utilization",
      "worst": "Worst",
      "best": "Best",
      "average": "Average"
    }
  }
}
